var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateAngle(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1336_27027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41115 9.30664C7.09237 9.36057 3.8906 9.34129 2.07508 9.32329C1.29444 9.31557 0.669434 8.67993 0.669434 7.89922V0.601562",
    stroke: "#6C757D",
    strokeWidth: 1.07143,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.669434 4.79932V7.89907C0.669434 8.67972 1.29444 9.31543 2.07508 9.32314C3.03045 9.33257 4.36969 9.34243 5.76213 9.34179C5.44144 6.80167 3.28872 4.83237 0.669434 4.79932Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.669434 4.79932V7.89907C0.669434 8.67972 1.29444 9.31543 2.07508 9.32314C3.03045 9.33257 4.36969 9.34243 5.76213 9.34179C5.44144 6.80167 3.28872 4.83237 0.669434 4.79932Z",
    stroke: "#6C757D",
    strokeWidth: 1.07143,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48233 7.59082L1.47217 8.60096",
    stroke: "#6C757D",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94667 4.12646L4.93652 5.13662",
    stroke: "#6C757D",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41102 0.662109L8.40088 1.67226",
    stroke: "#6C757D",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1336_27027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateAngle);
export default __webpack_public_path__ + "static/media/rotate_angle.2be2213ed268856014530be84413ee5b.svg";
export { ForwardRef as ReactComponent };